<table class="table participants">
    <thead>
        <tr>
            <th></th>
            <th>{{ 'form.social-name' | translate }}</th>
            <th class="d-none d-md-table-cell">
                {{ 'form.document' | translate }}
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-template ngFor let-participant [ngForOf]="participants" let-isFirst="first">
            <tr *ngIf="isFirst">
                <td>
                    <i class="icon-legal"></i>
                </td>
                <td>
                    <strong>{{ participant.name }}</strong>
                </td>
                <td class="d-none d-md-table-cell">
                    <strong>{{ participant.docId }}</strong>
                </td>
            </tr>
        </ng-template>
    </tbody>
</table>
